import { colors } from "@zfp-akademie-a-s/zfp-design";
export const goalHorizonHeaderStyles = { backgroundColor: colors.backgroundSecondary, boxShadow: "none", borderRadius: 2 };
